export async function fetchMaterials(q) {
  const url = q ? `/api/materials?q=${encodeURIComponent(q)}` : '/api/materials';
  const res = await fetch(url);
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const err = new Error(`HTTP ${res.status}` + (text ? `: ${text}` : ''));
    err.status = res.status;
    throw err;
  }
  const data = await res.json();
  if (!Array.isArray(data)) throw new Error('Invalid response from /api/materials');
  return data;
}

export function normalizeRow(row) {
  if (!row) return null;
  let metadata = {};
  try {
    if (row.metadata) {
      metadata = typeof row.metadata === 'string' ? JSON.parse(row.metadata) : row.metadata;
    }
  } catch (err) {
    metadata = {};
  }

  const toNumber = (v) => {
    if (v === null || v === undefined || v === '') return null;
    const n = Number(String(v).replace(',', '.'));
    return Number.isFinite(n) ? n : null;
  };

    const enclosedRaw = (row.enclosed !== undefined && row.enclosed !== null) ? row.enclosed : (metadata.enclosed !== undefined ? metadata.enclosed : null);
    const enclosed = enclosedRaw === null ? null : (enclosedRaw === true || enclosedRaw === 1 || String(enclosedRaw) === '1');

    return {
        id: row.id,
        name: row.name || row.short_code || '-',
        code: row.short_code || metadata.code || null,
        enclosed: enclosed,
        enclosedLabel: enclosed === true ? 'Tak' : enclosed === false ? 'Nie' : null,
        temp_min: toNumber(row.temp_min ?? metadata.temp_min ?? null),
        temp_max: toNumber(row.temp_max ?? metadata.temp_max ?? null),
        bed_temp_min: toNumber(row.bed_temp_min ?? metadata.bed_temp_min ?? null),
        bed_temp_max: toNumber(row.bed_temp_max ?? metadata.bed_temp_max ?? null),
        fan_speed_min: toNumber(row.fan_speed_min ?? metadata.fan_speed_min ?? null),
        fan_speed_max: toNumber(row.fan_speed_max ?? metadata.fan_speed_max ?? null),
        max_print_speed: toNumber(row.max_print_speed ?? metadata.max_print_speed ?? null),
        hardness: toNumber(row.hardness ?? metadata.hardness ?? null),
        hardness_scale: row.hardness_scale || metadata.hardness_scale || null,
        impact_strength: toNumber(row.impact_strength ?? metadata.impact_strength ?? null),
        tensile_strength: toNumber(row.tensile_strength ?? metadata.tensile_strength ?? null),
        use_adhesive: (row.use_adhesive !== undefined && row.use_adhesive !== null) ? !!Number(row.use_adhesive) : (metadata.use_adhesive !== undefined ? !!Number(metadata.use_adhesive) : false),
        density: toNumber(metadata.density ?? row.density ?? null),
        notes: row.notes ?? null,
        additional_properties: row.additional_properties ?? null,
        contaminants: Array.isArray(row.contaminants) ? row.contaminants.map(normalizeContaminant).filter(Boolean) : null,
        created_at: row.created_at ?? null,
        _raw: row,
    };
}

export function normalizeContaminant(c) {
  if (!c) return null;
  let metadata = {};
  try {
    if (c.metadata) metadata = typeof c.metadata === 'string' ? JSON.parse(c.metadata) : c.metadata;
  } catch (err) {
    metadata = {};
  }
  const toNumber = (v) => {
    if (v === null || v === undefined || v === '') return null;
    const n = Number(String(v).replace(',', '.'));
    return Number.isFinite(n) ? n : null;
  };
  return {
    id: c.id,
    short_code: c.short_code ?? null,
    material_id: c.material_id ?? null,
    filament_color: c.filament_color ?? null,
    product_mass: toNumber(c.product_mass ?? metadata.product_mass ?? null),
    pm1: toNumber(c.pm1 ?? metadata.pm1 ?? null),
    pm25: toNumber(c.pm25 ?? metadata.pm25 ?? null),
    pm10: toNumber(c.pm10 ?? metadata.pm10 ?? null),
    metadata: metadata,
    created_at: c.created_at ?? null,
    updated_at: c.updated_at ?? null,
    _raw: c,
  };
}

export async function fetchAndNormalize(q) {
  const raw = await fetchMaterials(q);
  return raw.map(normalizeRow).filter(Boolean);
}

export async function fetchMaterialById(id) {
  if (!id) return null;
  const res = await fetch(`/api/materials/${encodeURIComponent(id)}`);
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const err = new Error(`HTTP ${res.status}` + (text ? `: ${text}` : ''));
    err.status = res.status;
    throw err;
  }
  const row = await res.json();
  return normalizeRow(row);
}
